import { render, staticRenderFns } from "./gold.vue?vue&type=template&id=6f22365d"
import script from "./gold.vue?vue&type=script&lang=js"
export * from "./gold.vue?vue&type=script&lang=js"
import style0 from "./gold.vue?vue&type=style&index=0&id=6f22365d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports